import request from '@/utils/request'

export function getPartnerList(params) {
  return request({
    url: process.env.WEB_API + '/partner/getList',
    method: 'post',
    data: params
  })
}

export function addLinkCount (params) {
  return request({
    url: process.env.WEB_API + '/partner/addLinkCount',
    method: 'get',
    params
  })
}






// WEBPACK FOOTER //
// ./src/api/partner.js